<template>
    <v-card class="pb-5"> 
        <v-card-title class="grey lighten-4 p-2">
            <h4 class="m-0" v-if="is_seasonal">Number of Renters</h4>
            <h4 class="m-0" v-else>Dates of Rental</h4>
        </v-card-title>
        <v-row class="m-2">
            <!--            <v-col cols="12" md="5" order-md="2">-->
            <!--                <v-alert-->
            <!--                    outlined-->
            <!--                    elevation="2"-->
            <!--                >-->
            <!--                    <div class="font-weight-bold mb-3">Today is {{ todayFormatted }}</div>-->
            <!--                    *All reservations MUST be received no later than {{ inAdvanceRentalDays * 24 }} hours in advance ( Mountain Standard Time ).-->

            <!--                </v-alert>-->
            <!--            </v-col>-->
            <v-col cols="12" md="6">
                <v-row v-if="!is_seasonal">
                    <v-col cols="12">
                        <div class="date-range-container">
                            <div class="date-range-icons">
                                <v-icon>mdi-calendar-cursor</v-icon>
                            </div>
                            <div class="date-range-controls">
                                <v-dialog
                                    ref="dateStartDialog"
                                    v-model="dateStartModal"
                                    :return-value.sync="reservation.date_pickup"
                                    persistent
                                    @input="changeDatePickerMonth"
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <with-validation field="date_return" v-slot="{bind:v_bind}">
                                            <v-text-field
                                                v-model="datePickupFormatted"
                                                label="Start Day"
                                                hint="Day you start skiing?"
                                                :persistent-hint="true"
                                                :error="v_bind.error"
                                                :error-messages="v_bind.errorMessages"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </with-validation>
                                    </template>
                                    <div class="datepicker-wrapper" @click="setDateReturn">
                                        <h5 class="datepicker-header primary text-center white--text pt-3 mb-0">
                                            Start Date
                                        </h5>
                                        <v-date-picker
                                            class="custom-current-date-black"
                                            style="border-top-left-radius: 0;border-top-right-radius: 0"
                                            @change="validate(['date_pickup'])"
                                            :allowed-dates="allowedDatePickup"
                                            v-model="reservation.date_pickup"
                                            @input="$refs.dateStartDialog.save(reservation.date_pickup)"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="dateStartModal = false"
                                            >
                                                Cancel
                                            </v-btn>
                                        </v-date-picker>
                                    </div>
                                </v-dialog>
                                <v-dialog

                                    ref="dateEndDialog"
                                    v-model="dateEndModal"
                                    :return-value.sync="reservation.date_return"
                                    persistent
                                    width="290px"
                                >

                                    <template v-slot:activator="{ on, attrs }">
                                        <v-slide-x-transition>

                                            <with-validation field="date_return" v-slot="{bind:v_bind}">

                                                <v-text-field
                                                    class="ml-2"
                                                    v-model="dateReturnFormatted"
                                                    label="End Day"
                                                    :persistent-hint="true"
                                                    hint="Last day skiing? "
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :error="v_bind.error"
                                                    :error-messages="v_bind.errorMessages"
                                                ></v-text-field>
                                            </with-validation>
                                        </v-slide-x-transition>
                                    </template>
                                    <div class="datepicker-wrapper">
                                        <h5 class="datepicker-header primary text-center white--text pt-3 mb-0">
                                            End Date
                                        </h5>
                                        <v-date-picker
                                            class="custom-current-date-black"
                                            style="border-top-left-radius: 0;border-top-right-radius: 0"
                                            @change="validate(['date_return'])"
                                            :allowed-dates="allowedDateReturn"
                                            v-model="reservation.date_return"
                                            @input="$refs.dateEndDialog.save(reservation.date_return)"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="dateEndModal = false"
                                            >
                                                Cancel
                                            </v-btn>
                                        </v-date-picker>
                                    </div>
                                </v-dialog>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="mt-5 mb-5">
                    <v-col class="flex-grow-0 align-self-end p-0" style="flex-basis: 25px">
                        <v-icon style="margin-bottom: 10px;margin-left:10px">mdi-account-multiple</v-icon>
                    </v-col>
                    <v-col>
                        <with-validation v-slot="{ bind, on }" field="reservees_number">
                            <v-v-step-number
                                v-bind="bind"
                                v-on="on"
                                :min="1"
                                :max="($store.state.resources.config.frontend_view_folder === 'frontend.tygart') ? 25 : 20"
                            ></v-v-step-number>
                        </with-validation>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="is_local_accommodations" cols="6" md="6">
                        <h5>Delivery Location</h5>
                        <v-row class="m-2">
                            <v-text-field v-model="reservation.local_accommodations"></v-text-field>
                        </v-row>
                    </v-col>
            <v-col cols="6" md="6" :class="!is_seasonal?'pt-with-mobile':'pt-1'">
                <template v-if="useCoupon">
                    <h5 style="padding-top: 24px">Coupon</h5>
                    <v-row class="m-2">
                        <v-text-field v-model="reservation.coupon_id"></v-text-field>

                        <v-btn color="primary" @click="applyCoupon()">
                            Apply
                        </v-btn>
                    </v-row>
                    <v-row class="m-2">
                        <span :class="coupon_status===200?'text-success':'text-danger'" v-html="coupon_response"></span>
                    </v-row>
                </template>
                <template v-if="is_windhamoutfitters">
                    <h5>Where will you be skiing today:</h5>
                    <with-validation field="location" v-slot="{bind,on}">
                        <v-select
                            v-bind="bind"
                            v-on="on"
                            menu-props="left"
                            :items="locationsList"
                            item-text="title"
                            item-value="key"
                        >
                        </v-select>
                    </with-validation>
                </template>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" v-if="is_adventure_seasonal">
                <v-row class="m-2">
                    <h6>Please Select a Location:</h6>
                    <v-radio-group
                        v-model="reservation.location"
                        row
                    >
                        <v-radio
                            label="South side Location"
                            value="south"
                        ></v-radio>
                        <v-radio
                            label="North side Location"
                            value="north"
                        ></v-radio>
                    </v-radio-group>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="m-2">
            <v-col cols="12" md="6">
                <template v-if="return_day_after_kiosk">
                    <div>
                        <h5>
                            <v-icon>mdi-av-timer</v-icon>
                            <span>Do you want to return the day after?</span>
                        </h5>
                        <v-radio-group column v-model="reservation.return_day_after">
                            <v-radio value="yes" label="Yes"></v-radio>
                            <v-radio value="no" label="No"></v-radio>
                        </v-radio-group>
                    </div>
                </template>
            </v-col>

            <!--            <v-col  cols="6">-->
            <!--                <h5>-->
            <!--                    <v-icon>mdi-av-timer</v-icon>-->
            <!--                    Do you want to pick up the day before?-->
            <!--                </h5>-->
            <!--                <v-radio-group column v-model="reservation.pickup_day">-->
            <!--                    <v-radio value="day_before" label="Pick up the day before"></v-radio>-->
            <!--                    <v-radio value="day_of" label="Pick up day of"></v-radio>-->
            <!--                </v-radio-group>-->

            <!--            </v-col>-->

        </v-row>
    </v-card>


</template>
<script>
import moment                   from 'moment';
import ValidatableComponent     from "../../../../mixins/ValidatableComponent";
import DateUtilsMixin        from "../../../../mixins/DateUtilsMixin";
import {mapActions, mapGetters}             from "vuex";
import VVRangeDatepickerDialog  from "../../../../components/inputs/VVRangeDatepickerDialog";
import VVStepNumber             from "../../../../components/inputs/VVStepNumber";
import WithValidation           from "../../../../components/inputs/WithValidation";
import reservation_form__fields from "../../../../validation/fields/reservation_form__fields";
import reservation_form__rules  from "../../../../validation/scenarios/reservation_form__rules";
import {dateConvert} from "../../../../plugins/utils";

export default {
    name      : "DatesOfRental",
    components: {VVRangeDatepickerDialog, VVStepNumber, WithValidation},
    props     : ['validationId'],
    mixins    : [ValidatableComponent, DateUtilsMixin],
    data      : () => ({
        dateStartModal: false,
        dateEndModal  : false,
        dateStartSetStatus: false,
        setPickupDate: false,
        locationsList: [
            {
                key: "windham",
                title: "Windham Mountain"
            },
            {
                key: "hunter",
                title: "Hunter Mountain"
            },
            {
                key: "plattekill",
                title: "Plattekill Mountain"
            },
            {
                key: "belleayre",
                title: "Belleayre Mountain"
            }
        ]
    }),

    methods   : {
        ...mapActions(['load__pickup_hours', 'do_apply_coupon']),
        async applyCoupon() {
            this.do_apply_coupon();
        },

        allowedDatePickup(date) {
            let disableDate = false;
            if(this.$store.state.resources.config.kiosk_blocked_dates!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.kiosk_blocked_dates)) {
                    if(value.start!==null && value.end!==null) {
                        disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (disableDate) break;
                    }
                }
            }
            let {today, tomorrow} = this.$store.state.resources.kiosk_config;
            let any_pickup_date_kiosk = parseInt(this.$store.state.resources.config.any_pickup_date_kiosk);
            today = this.dt_obj_from_user(today)
            tomorrow = this.dt_obj_from_user(tomorrow)
            let season_end = this.$store.state.resources.config.season_end;
            let season_start = this.$store.state.resources.config.season_start;
            season_end = this.dt_obj_from_user(season_end);
            season_start = this.dt_obj_from_user(season_start);
            let start_date = season_start;
            if(!any_pickup_date_kiosk && (today >= season_start)){
                start_date = today;
            }
            if(!any_pickup_date_kiosk && (today < season_start)){
                today = season_start
                tomorrow = moment(season_start).add(1, 'days')
            }
            let allowedData = ((moment(season_start).isBefore(date) || moment(season_start).isSame(date)) && (moment(date).isAfter(today) || moment(date).isSame(today))) && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD') && (!any_pickup_date_kiosk ? today.startOf('day') <= moment(date, 'YYYY-MM-DD') &&
                tomorrow.endOf('day') >= moment(date, 'YYYY-MM-DD') : moment(season_start).isBefore(date) || moment(season_start).isSame(date));
            // if(this.reservation.single_day_type && this.reservation.single_day_type==='night'){
            //     allowedData = (moment(date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');
            // }
            return !disableDate && allowedData;
        },
        allowedDateReturn(date) {
            let disableDate = false;
            if(this.$store.state.resources.config.kiosk_blocked_dates!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.kiosk_blocked_dates)) {
                    if(value.start!==null && value.end!==null) {
                        disableDate = moment(date, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (disableDate) break;
                    }
                }
            }
            let season_end = this.$store.state.resources.config.season_end;
            season_end = this.dt_obj_from_user(season_end);
            let {endDate} = this.$store.state.resources.kiosk_config;
            endDate = this.dt_obj_from_user(endDate);

            if(!disableDate && parseInt(this.$store.state.resources.config.one_days_rate)){
                console.log('kk');
                return moment(date, 'YYYY-MM-DD').diff(moment(this.reservation.date_pickup), 'days')===0;
            }
            console.log('k22k');
            let allowedData = moment(this.reservation.date_pickup, 'YYYY-MM-DD') <= moment(date, 'YYYY-MM-DD')
                && endDate.endOf('day') >= moment(date, 'YYYY-MM-DD');
            if(this.reservation.single_day_type && (this.reservation.single_day_type==='afternoon' || this.reservation.single_day_type==='night' || this.reservation.single_day_type==='day_hours' || this.reservation.single_day_type==='night_hours')){
                allowedData = moment(date).format('YYYY-MM-DD') === moment(this.reservation.date_pickup).format('YYYY-MM-DD');
            }
            if(this.minimum_2_days_reservation){
                allowedData = moment(date).format('YYYY-MM-DD') !== moment(this.reservation.date_pickup).format('YYYY-MM-DD');
            }
            if(this.minimum_3_days_reservation){
                allowedData = moment(date).diff(moment(this.reservation.date_pickup), 'days')>=2;
            }
            return !disableDate && allowedData && season_end.endOf('day') >= moment(date, 'YYYY-MM-DD');

        },
        async updatePickupHours() {
            if (this.reservation.date_pickup && this.reservation.date_return) {
                await this.load__pickup_hours();
                this.reservation.pickup_hour = this.pickupHours[0].value;
            }
        },
        changeDatePickerMonth(){
            this.dateStartSetStatus = true;
            if(this.reservation.date_pickup == null){
                let {today} = this.$store.state.resources.kiosk_config;
                let any_pickup_date_kiosk = parseInt(this.$store.state.resources.config.any_pickup_date_kiosk);
                let season_end = this.$store.state.resources.config.season_end;
                let season_start = this.$store.state.resources.config.season_start;
                if (!this.$store.state.model.reservation.is_seasonal && today < season_start) {
                    let current_date = season_start;
                    if ((moment(today).format('YYYY-MM-DD') >= moment(season_start).format('YYYY-MM-DD')) && (moment(today).format('YYYY-MM-DD') <= moment(season_end).format('YYYY-MM-DD'))) {
                        current_date = today;
                    }
                    this.$store.state.model.reservation.date_pickup = moment(current_date).format('YYYY-MM-DD');
                }
            }else{
                this.dateStartSetStatus = false;
            }
        },
        setDateReturn(){
            if(this.reservation.date_return == null){
                this.dateEndModal = true;
                this.$store.state.model.reservation.date_return = this.$store.state.model.reservation.date_pickup;
            }
        },
        is_in_special_period() {
            let day = this.$store.state.model.reservation.date_pickup;
            let is_in_special_period = false;
            if(this.$store.state.resources.config.special_period_control && this.$store.state.resources.config.special_period!==null){
                for (const [key, value] of Object.entries(this.$store.state.resources.config.special_period)) {
                    if(value.start!==null && value.end!==null) {
                        is_in_special_period = moment(day, 'YYYY-MM-DD').isBetween(moment(value.start, 'MM/DD/YYYY'), moment(value.end, 'MM/DD/YYYY'), null, '[]');
                        if (is_in_special_period){
                            this.$store.commit('set_special_period_increase', parseFloat(value.special_rate));
                            this.$store.commit('set_special_period_start_date', value.start);
                            this.$store.commit('set_special_period_end_date', value.end);
                            break;
                        }
                    }
                }
            }
            if(!is_in_special_period){
                this.$store.commit('set_special_period_increase', 0);
            }
            this.$store.commit('set_is_special_period_date', is_in_special_period);
        }
    },
    computed  : {
        dateFormat() {
            return this.$store.state.config.dateFormat;
        },
        inAdvanceRentalDays() {
            return this.$store.state.resources.config.in_advance_rental_days;
        },
        useCoupon() {
            return this.$store.state.resources.config.use_coupons;
        },
        todayFormatted() {
            return moment().format(this.dateFormat);
        },
        totalDays() {
            if (this.reservation.date_pickup && this.reservation.date_return) {
                return moment(this.reservation.date_return).diff(moment(this.reservation.date_pickup), 'days');
            }
            return 0;
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        dateReturnFormatted() {
            if (this.reservation.date_return)
                return moment(this.reservation.date_return, 'YYYY-MM-DD').format(this.dateFormat);
            else
                return '';
        },
        datePickupFormatted() {
            if (this.reservation.date_pickup)
                return moment(this.reservation.date_pickup, 'YYYY-MM-DD').format(this.dateFormat);
            else
                return '';
        },
        is_seasonal(){
            return this.$store.state.model.reservation.is_seasonal;
        },
        season_return(){
            return this.$store.state.resources.config.season_return;
        },
        special_period_control() {
            return parseInt(this.$store.state.resources.config.special_period_control);
        },
        special_period() {
            return this.$store.state.resources.config.special_period;
        },
        minimum_2_days_reservation() {
            return parseInt(this.$store.state.resources.config.minimum_2_days_reservation);
        },
        minimum_3_days_reservation() {
            return parseInt(this.$store.state.resources.config.minimum_3_days_reservation);
        },
        is_local_accommodations(){
            return parseInt(this.$store.state.resources.config.local_accommodations);
        },
        is_adventure_seasonal(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.adventure" && window.location.href.includes('seasonal') && !window.location.href.includes("delivery")){
                return true;
            }
            return false;
        },
        is_windhamoutfitters() {
            return window.location.hostname == 'skirentals.windhamoutfitters.com';
        },
        return_day_after_kiosk(){
            return parseInt(this.$store.state.resources.config.return_day_after_kiosk);
        },
        ...mapGetters(['coupon_response', 'coupon_status'])

    },
    watch     : {
        'reservation.date_pickup': function (newVal, oldVal) {
            this.is_in_special_period();
            // if (!this.reservation.date_return && newVal && !this.dateStartSetStatus) {
            //     this.dateEndModal = true;
            //     this.$store.state.model.reservation.date_return = newVal;
            // }
        },
        '$store.state.model.reservation.date_return': function (newVal, oldVal) {
            if(this.$store.state.model.reservation.coupon_id && this.$store.state.model.reservation.coupon_id!==""){
                this.applyCoupon();
            }
        },
        validationId(val){
            this.withValidation({validationId: val})
        }
    }
}
</script>

<style scoped lang="scss">
.date-range-container {
    display: flex;
    flex-direction: row;
    justify-content: stretch;

    .date-range-icons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 0.5em;
    }

    .date-range-controls {
        flex-grow: 1;
        display: flex;
        justify-content: stretch;
    }

}
@media (max-width: 575.98px) {
    .pt-with-mobile{
        padding-top: 20px;
    }
}

@media (min-width: 576px){
    .pt-with-mobile{
        padding-top: 60px;
    }
}

</style>

<style>

.date-range-icons .v-icon {
    margin-bottom: 3px;
}

.v-application .custom-current-date-black .accent--text.v-date-picker-table__current{
    color: #000 !important;
    border-color: #1976d2 !important;
}
.v-application .custom-current-date-black .theme--light.v-btn.v-btn--disabled{
    color: rgba(0, 0, 0, 0.26) !important;
    border-color: rgba(0, 0, 0, 0.26) !important;
}

</style>
